import { types } from "mobx-state-tree";

const MetaStore = types
  .model({
    isLoading: types.boolean
  })
  .actions(self => ({
    setIsLoading(isLoading) {
      self.isLoading = isLoading
    }
  }));

export default MetaStore;